import {useEffect} from 'react'

const addBodyClass = className => document.body.classList.add(className)
const removeBodyClass = className => document.body.classList.remove(className)

export default function useBodyClass(className) {
  useEffect(() => {
    // Set up
      className instanceof Array ? className.forEach(addBodyClass) : addBodyClass(className)

    // Clean up
    return () => {
        className instanceof Array ? className.forEach(removeBodyClass) : removeBodyClass(className)
    }
  }, [className])
}
